import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {AttachFileDialogResponse, IconType, IoniconsOutline, PtPermissions} from '@pt/pt-models';
import {DialogService} from '../../../services/dialog.service';
import { Attachment } from 'it/primatoo/openapi/api/org/schemas/common/Attachment';

@Component({
  selector: 'pt-input-attachment',
  templateUrl: './input-attachment.component.html',
  styleUrls: ['./input-attachment.component.scss']
})
export class InputAttachmentComponent {

  @Input() attachments: Attachment[] = [];
  @Input() title: string;
  @Input() attachWithButton = false;
  @Input() noAttachmentMessage: string;
  @Input() hideBorders = false;
  @Input() showDelete: boolean;
  @Input() showDownload: boolean;
  @Input() readonly = false;
  @Input() disabledAdd = false;
  @Input() disabledDelete = false;
  @Output() attachmentExample: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() attachAction: EventEmitter<AttachFileDialogResponse> = new EventEmitter<AttachFileDialogResponse>();
  @Output() deleteAttachment: EventEmitter<Attachment> = new EventEmitter<Attachment>();
  @Output() downloadAttachment: EventEmitter<Attachment> = new EventEmitter<Attachment>();

  IconUpload = IoniconsOutline.upload;
  IconAttach = IoniconsOutline.attach;
  IconTrash = IoniconsOutline.trash;
  IconDownload = IoniconsOutline.download;
  SVG = IconType.SVG;
  PtPermissions = PtPermissions;

  constructor(
    private dialogService: DialogService,
    public translateService: TranslateService
  ) {
  }

  uploadAttachment() {
    if (!this.disabledAdd) {
      const title = this.translateService.stream('TITLE.ADD_FILE');
      this.dialogService.runAttachDialog(
        title
      ).subscribe(response => {
        if (response) {
          this.attachAction.emit(response);
        }
      });
    }
  }

}
